import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import type { MeterRoundDto } from "@klantpunt/shared";
import { api } from "../../lib/api";
import { hasModule, useMe } from "../../lib/auth";

interface MeterBuildingRow {
  building: { id: string };
  meters: number;
  openRound: MeterRoundDto | null;
  lastRound: MeterRoundDto | null;
}

/** Boven de meterlijst van een gebouw: de lopende opnameronde met voortgang, of de laatste ronde. */
export function MeterRoundCard({ buildingId }: { buildingId: string }) {
  const { data: me } = useMe();
  const canEdit = hasModule(me, "meters", "edit");
  const q = useQuery({
    queryKey: ["meter-buildings"],
    queryFn: () => api<MeterBuildingRow[]>("/meters/buildings"),
  });
  const row = q.data?.find((r) => r.building.id === buildingId);
  if (!row) return null;
  const round = row.openRound;
  const pct = round?.total ? Math.round((round.done / round.total) * 100) : 0;
  return (
    <section className="meterround" aria-label="Opnameronde">
      <span className="grow">
        <strong>{round ? round.name : "Geen lopende ronde"}</strong>
        {round && (
          <span className="dbar" aria-hidden="true">
            <span style={{ width: `${pct}%` }} />
          </span>
        )}
        <span className="muted small block">
          {round
            ? `${round.done} van ${round.total} opgenomen`
            : row.lastRound
              ? `Laatste ronde: ${row.lastRound.name}`
              : "Stel een schema in onder Meterstanden, of maak daar een ronde."}
        </span>
      </span>
      <span className="btnrow">
        {round && (
          <Link className="btn small" to={`/meterstanden/ronde/${round.id}`}>
            {canEdit ? "Verder met opnemen" : "Ronde bekijken"}
          </Link>
        )}
        <Link className="btn small ghost" to="/meterstanden">
          Rondes en schema
        </Link>
      </span>
    </section>
  );
}
